import { render, staticRenderFns } from "./editDep.vue?vue&type=template&id=6d53aed2"
import script from "./editDep.vue?vue&type=script&lang=js"
export * from "./editDep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports